const getTemplatesInfo = async (templateLoader, payload) => {
	const response = await templateLoader(payload, true);
	return response;
};

export default getTemplatesInfo;
